import { render } from "./ReglasNegocioPage.vue?vue&type=template&id=263c9678"
import script from "./ReglasNegocioPage.vue?vue&type=script&lang=js"
export * from "./ReglasNegocioPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__